export default {
  'resetpassword.maintext':
    'Чтобы поминять пароль, введите новый пароль в обоих полях',
  'resetpassword.retypepassword': 'Повторите пароль',
};
